/* PD collection pages: leaf gate (one spinner until the feed has its products, then everything
   appears at once), "Filtre" pill + drawer for the feed's filter sidebar, count sync, and the
   "Læs mere" SEO boxes. init() runs on load and again after a soft navigation (pd:navigated). */
(function () {
  "use strict";
  var overlay, feedObserver, closeTimer;
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>';
  function q(s) { return document.querySelector(s); }
  function labels() { var leaf = q("[data-pd-leaf]"); return { filters: (leaf && leaf.dataset.filtersLabel) || "Filters", more: (leaf && leaf.dataset.showMoreLabel) || "Show more", close: (leaf && leaf.dataset.closeLabel) || "Close", reset: (leaf && leaf.dataset.resetLabel) || "Reset filters" }; }
  /* active filters = the app's own ?pf= list (brands, price, …) */
  function activeFilters() { try { var a = JSON.parse(new URL(location.href).searchParams.get("pf") || "[]"); return Array.isArray(a) ? a.length : 0; } catch (e) { return 0; } }
  /* Reset: untick everything at once, drop ?pf= and let the app refetch through its own popstate handler —
     one request, and the same fade → circle → fade-in as a single filter change */
  function resetFilters() {
    var sb = q(".fitment-feed .pd-sidebar"); if (sb) sb.querySelectorAll("input[data-pf-f]:checked").forEach(function (i) { i.checked = false; i.closest(".pd-check").classList.remove("is-on"); });
    var url = new URL(location.href); url.searchParams.delete("pf"); url.searchParams.delete("page");
    history.pushState({ pdFeed: true }, "", url.toString());
    window.dispatchEvent(new PopStateEvent("popstate"));
    syncReset();
  }
  function syncReset() { var b = q(".pd-sidebar .pd-filters__reset"); if (b) b.hidden = !activeFilters(); }
  /* the filter drawer = the app's own sidebar, shown as a plain square panel from the right (same look as the
     product page's slide-out panel): dimmed overlay, head with title + close, everything below scrolls */
  function ensureChrome() {
    if (overlay) return;
    overlay = document.createElement("div"); overlay.className = "pd-filters-overlay"; overlay.hidden = true; overlay.innerHTML = "<span hidden></span>"; overlay.addEventListener("click", close);   /* a child: Hyper hides empty divs */
    document.body.appendChild(overlay);
  }
  function isOpen() { return document.body.classList.contains("pd-filters-open"); }
  function open() {
    ensureChrome(); clearTimeout(closeTimer); dressSidebar();
    document.body.classList.add("pd-filters-open"); overlay.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { document.body.classList.add("pd-filters-in"); }); });   // display first, then the slide-in transition
    var c = q(".pd-sidebar .pd-filters__close"); if (c) c.focus({ preventScroll: true });
  }
  function close() {
    if (!isOpen()) return;
    document.body.classList.remove("pd-filters-in");
    closeTimer = setTimeout(function () { document.body.classList.remove("pd-filters-open"); if (overlay) overlay.hidden = true; }, 340);
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { close(); ddCloseAll(); } });
  document.addEventListener("click", function (e) {   // anywhere outside the panel (and its button) closes it
    // A target that is no longer in the document tells us nothing about where
    // the click landed. The app's "show all" handler removes its own button
    // before the click finishes bubbling, so by the time we get here closest()
    // walks a detached node, finds no .pd-sidebar, and we shut the panel the
    // customer was in the middle of using.
    if (!e.target.isConnected) return;
    if (isOpen() && !e.target.closest(".pd-sidebar, .pd-filterbtn")) close();
    if (!e.target.closest(".pd-dd")) ddCloseAll();
  });
  /* head + expanded, capped lists. The app re-renders the sidebar's innerHTML after every fetch, so this is
     idempotent and re-run from the feed observer. */
  function dressSidebar() {
    var sb = q(".fitment-feed .pd-sidebar"); if (!sb || !q("[data-pd-leaf]")) return;
    var L = labels();
    if (!sb.querySelector(".pd-filters__head")) {
      var head = document.createElement("div"); head.className = "pd-filters__head";
      head.innerHTML = '<h2 class="pd-filters__title"></h2><button type="button" class="pd-filters__reset" hidden></button><button type="button" class="pd-filters__close"></button>';
      head.firstChild.textContent = L.filters;
      var reset = head.querySelector(".pd-filters__reset"); reset.textContent = L.reset; reset.addEventListener("click", resetFilters);
      head.lastChild.setAttribute("aria-label", L.close); head.lastChild.innerHTML = ICON_CLOSE; head.lastChild.addEventListener("click", close);
      sb.insertBefore(head, sb.firstChild);
    }
    syncReset();
    // a selection with no results can leave the app with no facets at all — never show a blank panel
    var empty = sb.querySelector(".pd-filters__none");
    if (!sb.querySelector(".pd-fg")) { if (!empty) { empty = document.createElement("p"); empty.className = "pd-filters__none"; empty.textContent = (q("[data-pd-leaf]") || { dataset: {} }).dataset.noFiltersLabel || "No filters available for this selection."; sb.appendChild(empty); } }
    else if (empty) empty.remove();
    sb.querySelectorAll(".pd-fg").forEach(function (fg) {
      fg.classList.add("is-open");   // every group unfolded
      var more = fg.querySelector(".pd-fg__more"), rows = fg.querySelectorAll(".pd-check");
      if (more) {
        rows.forEach(function (r, i) { r.style.display = i < 10 ? "" : "none"; });   // 10 visible, the app's "show all" reveals the rest
        if (!more.dataset.pdDressed) { more.dataset.pdDressed = "1"; var title = (fg.querySelector(".pd-fg__head span") || {}).textContent || ""; more.innerHTML = "<span></span>" + ICON_DOWN; more.firstChild.textContent = L.more + " " + title.trim().toLowerCase(); more.setAttribute("role", "button"); more.tabIndex = 0; more.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); more.click(); } }); }
      }
    });
  }
  /* custom sort dropdown on top of the app's native <select>: the select stays (hidden) and is what the app
     listens to; picking an option sets its value and fires change */
  function ddCloseAll() { document.querySelectorAll(".pd-dd.is-open").forEach(function (dd) { ddSet(dd, false); }); }
  function ddSet(dd, open) {
    var btn = dd.querySelector(".pd-dd__btn"), menu = dd.querySelector(".pd-dd__menu");
    var bar = dd.closest(".pd-toolbar__right"); if (bar) bar.classList.toggle("pd-dd-open", !!open);
    if (open) { menu.hidden = false; requestAnimationFrame(function () { dd.classList.add("is-open"); }); btn.setAttribute("aria-expanded", "true"); }
    else { dd.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false"); setTimeout(function () { if (!dd.classList.contains("is-open")) menu.hidden = true; }, 220); }
  }
  function dressSort() {
    document.querySelectorAll(".fitment-feed .pd-select select[data-pd-sort]").forEach(function (sel) {
      if (sel.dataset.pdDd) return; sel.dataset.pdDd = "1";
      var wrap = sel.parentElement; wrap.classList.add("is-dd");
      var dd = document.createElement("div"); dd.className = "pd-dd";
      var btn = document.createElement("button"); btn.type = "button"; btn.className = "pd-dd__btn"; btn.setAttribute("aria-haspopup", "listbox"); btn.setAttribute("aria-expanded", "false");
      btn.innerHTML = '<span class="pd-dd__val"></span>' + ICON_DOWN;
      var menu = document.createElement("div"); menu.className = "pd-dd__menu"; menu.setAttribute("role", "listbox"); menu.hidden = true;
      var sync = function () { btn.firstChild.textContent = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : ""; menu.querySelectorAll(".pd-dd__opt").forEach(function (o) { var on = o.dataset.value === sel.value; o.classList.toggle("is-on", on); o.setAttribute("aria-selected", on ? "true" : "false"); }); };
      var lab = wrap.parentElement && wrap.parentElement.querySelector("span");   // the app's "Sortér efter" label: a colon, and the whole pill opens the menu
      if (lab && lab !== wrap && !/[:：]\s*$/.test(lab.textContent)) lab.textContent = lab.textContent.replace(/\s*$/, ":");
      var pill = wrap.closest(".pd-sort");
      if (pill && !pill.dataset.pdDd) { pill.dataset.pdDd = "1"; pill.addEventListener("click", function (e) { if (e.target.closest(".pd-dd__menu") || e.target.closest(".pd-dd__btn")) return; e.stopPropagation(); btn.click(); });   /* stop the document "click outside" handler from closing what we just opened */ }
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var b = document.createElement("button"); b.type = "button"; b.className = "pd-dd__opt"; b.setAttribute("role", "option"); b.dataset.value = o.value; b.style.setProperty("--i", i);
        b.innerHTML = "<span></span>" + ICON_CHECK; b.firstChild.textContent = o.text;
        b.addEventListener("click", function () { if (sel.value !== o.value) { sel.value = o.value; sel.dispatchEvent(new Event("change", { bubbles: true })); } sync(); ddSet(dd, false); btn.focus(); });
        menu.appendChild(b);
      });
      btn.addEventListener("click", function () { var willOpen = !dd.classList.contains("is-open"); ddCloseAll(); if (willOpen) { ddSet(dd, true); var on = menu.querySelector(".pd-dd__opt.is-on"); setTimeout(function () { (on || menu.firstChild).focus({ preventScroll: true }); }, 30); } });
      dd.addEventListener("keydown", function (e) {
        var opts = Array.prototype.slice.call(menu.querySelectorAll(".pd-dd__opt")), i = opts.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); if (!dd.classList.contains("is-open")) ddSet(dd, true); (opts[i + 1] || opts[0]).focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
        else if (e.key === "Tab") ddSet(dd, false);
      });
      sel.addEventListener("change", sync);
      dd.appendChild(btn); dd.appendChild(menu); wrap.appendChild(dd); sync();
    });
  }

  /* Nul dele til den valgte MC er en anden besked end et lavt tal, men stod i samme grå hvisken
     som "3 dele passer din motorcykel" (merchant 2026-09-25). Tallet står i <strong>; er det 0,
     får linjen sin egen amber-pille.

     Universal-kontakten er det præcise signal om at der ER valgt en MC: widgeten tegner kun den
     på en kollektion med et køretøj. Uden den viser tælleren kollektionens eget antal, og dér er
     0 ikke en tilstand men bare en tom kategori.

     Flaget sidder på feed-roden og IKKE på tælleren selv: widgeten gen-tegner værktøjslinjen, og
     så følger en klasse på tælleren med i faldet. Målt — i nogle indlæsninger stod pillen, i
     andre ikke. Roden overlever, og den her kaldes uden debounce fra observeren, så den er sat
     igen i samme tick som gen-tegningen. */
  /* Den aktive MC i garagen. Nøglen er `year|make|model` af de NORMALISEREDE felter —
     samme format widgeten selv skriver (vehicleKey i fitment-widgets.js). */
  function activeBike() {
    try {
      var key = localStorage.getItem("fitment_garage_active"); if (!key) return null;
      var list = JSON.parse(localStorage.getItem("fitment_garage") || "[]");
      for (var i = 0; i < list.length; i++) {
        var b = list[i];
        if ([b.year, b.make, b.model].join("|") === key) return b;
      }
      var p = key.split("|");
      return p.length >= 3 ? { year: p[0], make: p[1], model: p[2] } : null;   /* garagen kan være ryddet uden at nøglen er det */
    } catch (e) { return null; }
  }

  /* Kategorioversigtens fliser: hvor mange dele i hver underkategori passer den valgte MC.
     Uden en MC i garagen sker der ingenting — så er flisen bare en flise (merchant 2026-09-25:
     "den skal jo bare vise det tal der står ligesom inde i kollektion siden").

     Ét kald for hele gitteret, ikke ét pr. flise. Tallet er præcis det kollektionssiden viser:
     serveren tæller på de samme fitments og det samme produkt-cache. Fejler kaldet, bliver
     fliserne stående uden tal — en manglende oplysning, ikke en ødelagt side. */
  function catCounts() {
    var grid = q("[data-pd-cat-counts]"); if (!grid || grid.dataset.pdCounted) return;
    var bike = activeBike(); if (!bike) return;
    var items = [].slice.call(grid.querySelectorAll("[data-pd-cat-id]"));
    var ids = items.map(function (el) { return el.dataset.pdCatId; }).filter(Boolean);
    if (!ids.length || !window.fetch) return;
    grid.dataset.pdCounted = "1";
    /* Serveren har allerede skrevet kollektionens EGET antal i flisen. Det er et rigtigt tal,
       bare et andet spørgsmål end det vi er ved at stille, så det tones ned mens svaret er
       undervejs i stedet for at blive stående som om det var svaret. */
    var chips = items.map(function (el) { return el.querySelector("[data-pd-cat-fit]"); }).filter(Boolean);
    var clearPending = function () { chips.forEach(function (c) { c.classList.remove("is-pending"); }); };
    chips.forEach(function (c) { c.classList.add("is-pending"); });
    setTimeout(clearPending, 6000);   /* svaret kan udeblive helt; en flise må ikke stå nedtonet for evigt */
    var base = (grid.dataset.apiBase || "https://pd-garage.fly.dev").replace(/\/$/, "");
    var uni = "false"; try { if (localStorage.getItem("fitment_universal_toggle") === "true") uni = "true"; } catch (e) {}
    var qs = "shop=" + encodeURIComponent(grid.dataset.shop || "")
      + "&year=" + encodeURIComponent(bike.year || "")
      + "&make=" + encodeURIComponent(bike.make || "")
      + "&model=" + encodeURIComponent(bike.model || "")
      + "&include_universal=" + uni
      + "&ids=" + encodeURIComponent(ids.join(","));
    fetch(base + "/api/storefront/collection-counts?" + qs)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.counts) return clearPending();
        var label = grid.dataset.fitLabel || "";
        items.forEach(function (el) {
          var n = data.counts[el.dataset.pdCatId];
          if (n == null) return;   /* serveren kunne ikke slå kollektionen op — så siger flisen ingenting */
          var chip = el.querySelector("[data-pd-cat-fit]"); if (!chip) return;
          chip.innerHTML = "<b></b> <span></span>";
          chip.firstChild.textContent = n > 5000 ? "5000+" : String(n);   /* same cap as the feed toolbar */
          chip.lastChild.textContent = label;
          chip.classList.remove("is-pending");
        });
        clearPending();   /* også de fliser serveren ikke kunne svare for */
      })
      .catch(clearPending);
  }

  function zeroFlag() {
    var feed = q(".fitment-feed"); if (!feed) return;
    var count = feed.querySelector(".pd-toolbar__count");
    var strong = count && count.querySelector("strong");
    var n = strong ? strong.textContent.replace(/\D/g, "") : "";
    var zero = n === "0" && !!feed.querySelector(".pd-uni-switch") ? "1" : "0";
    if (feed.getAttribute("data-pd-zero") !== zero) feed.setAttribute("data-pd-zero", zero);   /* kun ved ændring: ellers en uendelig runde med observeren */
  }

  function inject() {
    var leaf = q("[data-pd-leaf]"), label = (leaf && leaf.dataset.filtersLabel) || "Filters";
    var right = q(".fitment-feed .pd-toolbar__right");
    var uni = q(".fitment-feed .pd-toolbar > .pd-uni-switch");
    if (uni && right) right.insertBefore(uni, right.firstChild);   // the universal-products switch joins the pills on the right
    if (right && !right.querySelector(".pd-filterbtn") && q(".fitment-feed .pd-sidebar")) {
      var b = document.createElement("button"); b.type = "button"; b.className = "pd-filterbtn"; b.setAttribute("aria-haspopup", "dialog");
      b.innerHTML = '<span></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 7h16M7 12h10M10 17h4"/></svg>'; b.firstChild.textContent = label;
      b.addEventListener("click", open); right.insertBefore(b, right.firstChild);
    }
    dressSidebar(); dressSort();
    var count = q(".fitment-feed .pd-toolbar__count"), target = q("[data-pd-leaf-count]");
    if (count && target) { var base = count.cloneNode(true); var vl = base.querySelector(".pd-veh-line"); if (vl) vl.remove(); var t = base.textContent.replace(/\s+/g, " ").trim(); if (t && target.dataset.last !== t) { target.dataset.last = t; target.textContent = t; } }
    zeroFlag();

  }

  /* "Læs mere" boxes (hub SEO text + the collection text under the feed) */
  function seoBoxes() {
    document.querySelectorAll("[data-pd-seo]").forEach(function (box) {
      if (box._pdSeo) return; box._pdSeo = true;
      var text = box.querySelector("[data-pd-seo-text]"), btn = box.querySelector("[data-pd-seo-toggle]"), lab = box.querySelector("[data-pd-seo-label]");
      if (!text || !btn) return;
      if (text.scrollHeight <= text.clientHeight + 2) { box.classList.remove("is-collapsed"); btn.hidden = true; return; }
      btn.addEventListener("click", function () {
        var open = !box.classList.toggle("is-collapsed");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (lab) lab.textContent = open ? lab.dataset.less : lab.dataset.more;
      });
    });
  }

  /* Leaf gate: the overview section ships a spinner + an inline <style> that hides the title, the
     feed and everything after it. Reveal when the feed has rendered (cards, an empty state or the
     list view) and the first visible images have loaded — or after 8 s as a safety net. */
  /* Product lists show the page IMMEDIATELY with grey placeholder cards, and the real ones fade in
     when the feed answers (merchant 2026-09-11: the old gate hid the whole page behind a spinner, so
     even a 300ms request felt like a wait). Hub pages are server-rendered and just reveal. */
  /* the placeholder grid is server-rendered (pd-category-overview.liquid) so it is on screen at first
     paint; drop it as soon as the feed has real cards, or after 12s as a safety net */
  /* the grey cards and the placeholder toolbar above them (pd-category-overview.liquid) go together */
  /* The placeholders go the moment the feed has its FIRST real card, which is before the rest of the grid is
     drawn: on a phone the content collapsed for ~240 ms and the footer jumped into view and out again (CLS
     1.25 of the page's 1.39, measured 2026-09-27). The main column keeps its height until the feed has
     stopped growing (two quiet checks 150 ms apart, 2 s at most); a short list then settles once. */
  function dropSkel() {
    var main = q(".pd-frame__main") || document.getElementById("MainContent"), feed = q(".fitment-feed");
    if (main && feed && q("[data-pd-skelgrid]") && !main.style.minHeight) {
      main.style.minHeight = main.offsetHeight + "px";
      var last = -1, quiet = 0, t0 = Date.now();
      var iv = setInterval(function () {
        var h = feed.offsetHeight; quiet = h === last ? quiet + 1 : 0; last = h;
        if (quiet >= 2 || Date.now() - t0 > 2000) { clearInterval(iv); main.style.minHeight = ""; }
      }, 150);
    }
    ["[data-pd-skelgrid]", "[data-pd-skeltool]"].forEach(function (s) { var e = q(s); if (e) e.remove(); });
  }
  function skeletons() {
    var skel = q("[data-pd-skelgrid]"); if (!skel) { dropSkel(); return; }
    var feed = q(".fitment-feed"); if (!feed) { dropSkel(); return; }
    if (feed.querySelector(".pd-grid .pd-card, .pd-listview .pd-row")) { dropSkel(); return; }
    if (skel.dataset.pdWatch) return; skel.dataset.pdWatch = "1";
    var slow = setTimeout(function () { var s = q("[data-pd-skelgrid]"); if (s) s.classList.add("is-slow"); }, 1400);   /* taking a while → deeper sweep */
    var done = function () { clearTimeout(slow); clearTimeout(stall); dropSkel(); mo.disconnect(); };
    var mo = new MutationObserver(function () {
      if (feed.querySelector(".pd-grid .pd-card, .pd-listview .pd-row")) return done();
      var box = feed.querySelector(".pd-empty:not([hidden]):not([data-fitment-feed-loading]), .pd-error:not([hidden])");
      if (box) done();
    });
    mo.observe(feed, { childList: true, subtree: true });
    /* The placeholders used to be dropped after 12 s no matter what. When the feed had not answered
       by then the page collapsed to the title with the SEO link list right under it — which is what
       the merchant opened "Alle servicedele" to (2026-09-23). Now they stay until the feed renders
       cards or one of its own state boxes, and after 12 s they say so and offer a retry. */
    var stall = setTimeout(function () {
      var s = q("[data-pd-skelgrid]"); if (!s || s.querySelector(".pd-skel-stall")) return;
      var leaf = q("[data-pd-leaf]") || { dataset: {} };
      var li = document.createElement("li"); li.className = "pd-skel-stall";
      li.innerHTML = "<p></p><button type=\"button\" class=\"pd-skel-stall__retry\"></button>";
      li.firstChild.textContent = leaf.dataset.feedSlowLabel || "Loading the products is taking longer than usual.";
      li.lastChild.textContent = leaf.dataset.retryLabel || "Try again";
      li.lastChild.addEventListener("click", function () { location.reload(); });
      s.classList.add("is-stalled"); s.appendChild(li);
    }, 12000);
  }
  function gate() {
    var style = q("style[data-pd-gate]"), spin = q("[data-pd-gate-spinner]");
    // A named gate (the wishlist's, layout/theme.liquid) is released by its own script. Taken here after a tab-bar
    // swap from a category page, it showed the list before it was drawn and ran a second entrance on top.
    if (style && style.getAttribute("data-pd-gate")) return;
    if (q("[data-pd-leaf]")) {   /* product list: no gate at all — show the shell + placeholders */
      if (style) style.remove();
      if (spin) spin.remove();
      var mainEl0 = document.getElementById("MainContent"); if (mainEl0) mainEl0.classList.remove("is-swapped");
      inject(); seoBoxes(); skeletons();
      return;
    }
    if (!style) { if (spin) spin.remove(); return; }
    var feed = q(".fitment-feed"), done = false, t0 = Date.now(), MIN = 350;
    // desktop: the spinner must sit exactly where the navigation spinner was (frame top + 30px), whatever
    // the section's own offset is — otherwise the circle "jumps" between the two
    if (spin && spin.classList.contains("pd-leaf-gate") && window.matchMedia("(min-width: 1024px)").matches) {
      var frame = q(".pd-frame"), sec = spin.closest(".shopify-section");
      if (frame && sec) { spin.style.top = Math.round(frame.getBoundingClientRect().top + 30 - sec.getBoundingClientRect().top) + "px"; }
    }
    var targets = q(".pd-cat-section")
      ? [q(".pd-leaf")].concat(Array.prototype.slice.call(document.querySelectorAll(".pd-cat-section ~ .shopify-section"))).filter(Boolean)
      : Array.prototype.slice.call(document.querySelectorAll("#MainContent > .shopify-section"));   // page gate (find-dele): every section
    function reveal() {
      if (done) return; done = true;
      var left = Math.max(0, MIN - (Date.now() - t0));
      setTimeout(function () {
        if (spin) spin.classList.add("is-done");   // the circle fades out first …
        setTimeout(function () {
          var mainEl = document.getElementById("MainContent"); if (mainEl) mainEl.classList.remove("is-swapped");   // its pdSwap ran under the gate; pdReveal plays now
          style.remove(); if (spin) spin.remove();
          targets.forEach(function (el) { el.classList.add("pd-revealed"); });   // … then the page fades in
          setTimeout(function () { targets.forEach(function (el) { el.classList.remove("pd-revealed"); }); }, 700);
          inject(); seoBoxes();
        }, 180);
      }, left);
    }
    // the feed keeps its state boxes (choose bike / loading / error / no results) in the DOM and
    // toggles [hidden]; "ready" = cards rendered, or a VISIBLE state box that is not the loading one
    function ready() {
      if (!feed) return false;
      if (feed.querySelector(".pd-grid .pd-card, .pd-listview .pd-row")) return true;
      var shown = Array.prototype.slice.call(feed.querySelectorAll(".pd-empty:not([hidden]), .pd-error:not([hidden])"));
      return shown.some(function (el) { return !el.hasAttribute("data-fitment-feed-loading") && !/loading|henter|indl/i.test(el.textContent); });
    }
    function whenImages(cb) {   // first two rows of thumbnails (grid or list view), capped at 3 s
      var imgs = Array.prototype.slice.call(feed.querySelectorAll(".pd-grid .pd-card .pd-thumb__art img, .pd-listview .pd-row img")).slice(0, 8).filter(function (i) { return !i.complete; });
      if (!imgs.length) return cb();
      var left = imgs.length, fired = false; var finish = function () { if (!fired) { fired = true; cb(); } };
      imgs.forEach(function (i) { var one = function () { if (--left <= 0) finish(); }; i.addEventListener("load", one); i.addEventListener("error", one); });
      setTimeout(finish, 3000);
    }
    function whenPrices(cb) {    // live prices replace the skeletons shortly after the cards; wait for the first 8, capped at 1.2 s
      var t1 = Date.now();
      (function poll() {
        var skel = feed.querySelectorAll(".pd-grid .pd-card [data-pd-price-skeleton] .pd-price-skel, .pd-listview .pd-row [data-pd-price-skeleton] .pd-price-skel");
        var first = Array.prototype.slice.call(feed.querySelectorAll(".pd-grid .pd-card, .pd-listview .pd-row")).slice(0, 8);
        var pending = first.some(function (c) { return c.querySelector(".pd-price-skel"); });
        if (!pending || !skel.length || Date.now() - t1 > 1200) return cb();
        setTimeout(poll, 80);
      })();
    }
    // settle: the feed sometimes loads in two phases (server page, then the bike filter) — only reveal once
    // the loading box has stayed hidden for a moment and the result is still there
    function settled(cb) {
      var box = feed.querySelector("[data-fitment-feed-loading]"), t1 = Date.now();
      (function poll() {
        var loading = box && !box.hidden;
        if (!loading && ready()) { if (Date.now() - t1 >= 250) return cb(); return setTimeout(poll, 50); }
        t1 = Date.now(); if (Date.now() - t0 > 7000) return cb(); setTimeout(poll, 50);
      })();
    }
    function check() { if (done) return true; if (!ready()) return false; whenImages(function () { whenPrices(function () { settled(function () { setTimeout(reveal, 60); }); }); }); return true; }
    if (!feed) { reveal(); return; }
    if (!check()) {
      var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
      mo.observe(feed, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); reveal(); }, 8000);
    }
  }

  /* after the gate: the app's "Loading parts…" box is hidden by the theme; while the feed re-fetches
     (sort, page, filters, bike change) the grid dims and our own circle sits on top of it */
  function busyWatch() {
    var feed = q(".fitment-feed"), box = feed && feed.querySelector("[data-fitment-feed-loading]"), main = feed && feed.querySelector(".pd-main");
    if (!feed || !box || !main || feed._pdBusy) return; feed._pdBusy = true;
    var spin = document.createElement("div"); spin.className = "pd-busy"; spin.setAttribute("aria-hidden", "true"); spin.innerHTML = '<span class="pd-loading__spin"></span>'; main.appendChild(spin);
    /* re-fetches only: on the FIRST load the placeholder cards are the waiting state, and marking the
       feed busy there put the grid at opacity 0 under the cards' own fade-in — two fades multiplied,
       which read as a quick pop next to the page transition (merchant 2026-09-23) */
    var hasCards = function () { return !!feed.querySelector(".pd-grid .pd-card, .pd-listview .pd-row"); };
    var sync = function () { var gated = !!q("style[data-pd-gate]"); feed.classList.toggle("is-busy", !box.hidden && !gated && hasCards()); };
    new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ["hidden"] });
    sync();
  }
  /* "Inkludér universale produkter" on list pages: the app reloads the page with ?universal=1 — the same
     fade → spinner → new page (gate) feedback as every other navigation instead of a raw reload */
  document.addEventListener("change", function (e) {
    var t = e.target; if (!t || !t.matches || !t.matches("[data-pd-uni]")) return;
    if (!q(".pd-cat-section") || !(window.pdNav && window.pdNav.leave)) return;   // only the server-paged collection pages reload; find-dele filters in place
    e.stopImmediatePropagation();
    var url = new URL(location.href);
    if (t.checked) url.searchParams.set("universal", "1"); else url.searchParams.delete("universal");
    url.searchParams.delete("page");
    try { var st = JSON.parse(localStorage.getItem("fitment_feed_pdstate") || "{}"); st.includeUniversal = !!t.checked; localStorage.setItem("fitment_feed_pdstate", JSON.stringify(st)); } catch (err) {}   // the app's own state key (PD_STATE_KEY): the toggle stays on across pages until switched off
    window.pdNav.leave(url.href);
  }, true);
  function init() {
    if (feedObserver) { feedObserver.disconnect(); feedObserver = null; }
    var feed = q(".fitment-feed") || document.body;
    feedObserver = new MutationObserver(function () { try { dressSidebar(); dressSort(); zeroFlag(); var tr = q(".fitment-feed .pd-toolbar__right"); if (tr && !tr.querySelector(".pd-filterbtn")) inject(); } catch (err) {} clearTimeout(inject._t); inject._t = setTimeout(inject, 60); });   // dress at once (the app just re-rendered the toolbar/sidebar), the rest debounced
    // a freshly drawn toolbar gets its Filtre pill + switch in the SAME frame: debounced, it painted once at 70px and
    // then jumped to its 120px two-row layout on phones (merchant 2026-09-26, the placeholder toolbar is 120 from the start)
    feedObserver.observe(feed, { childList: true, subtree: true });
    gate(); inject(); seoBoxes(); busyWatch(); skeletons(); catCounts();
  }
  init();
  document.addEventListener("pd:navigated", init);
  document.addEventListener("shopify:section:load", init);   // theme editor re-renders the section (fresh gate style + spinner)
  window.addEventListener("pageshow", function (e) { if (e.persisted && document.querySelector("style[data-pd-gate]")) init(); });
})();
